import { CreateInvoiceGroup, transformInvoice } from "../Helper/Helper";
import { ADD_INVOICE_TO_CART } from "../consultaExpress/service";
import { comerceNumber } from "../../consultForm/Helpers/constants";
import { recoletNewVals } from "../Helper/Helper";
import {
    UFStorage,
    cartsIdStorage,
    newInvoceStorage
} from "../Helper/Helper";
import axios from "axios";
import config from "../../../config/config";
import { GetToken } from "../../consultForm/Requests/movistar";


//////////////////////////////////
// CONSULT INVOICE INDIVIDUAL ::::
async function lazyRequest(data: any, count: number, callb: (E: any) => void, pending: any): Promise<any> {

    let filial = comerceNumber[sessionStorage.getItem('filial') || 'movistar'];
    let response = await ADD_INVOICE_TO_CART(data, null)
    let invoice: any = null;

    let { result, ultrafacturas, invRequest } = response;

    if (invRequest) {
        callb(invRequest);
        return;
    }

    if (result && ultrafacturas && ultrafacturas?.facturas?.length) {
        let UF = response.ultrafacturas;
        let originalInvoice = UF.facturas[0];

        if (filial !== 1) invoice = transformInvoice(originalInvoice, filial)
        else invoice = originalInvoice;


        callb(invoice);

        recoletNewVals({
            cartId: UF.id,
            invoiceID: invoice.identificadorEmpresa
        }, cartsIdStorage);


        UF.facturas = recoletNewVals(originalInvoice, newInvoceStorage);
        !invRequest && sessionStorage.setItem(UFStorage, JSON.stringify(UF))
        return true;
    }
    else {
        count++
        if (count < 5) {
            await lazyRequest(data, count, callb, pending)
            return true
        }
        else return false
    }
}


//////////////////////////////////
// CONSULT INVOICE INDIVIDUAL ::::
async function ControlInvoiceResponse(

    dataInvoice: any,
    handler: (ele: any) => void,
    filial: number,
    pending: any
) {
    let count: number = 0;
    let params: any = null;


    if (filial !== 1) {
        params = { ...dataInvoice }.consulta;
        params.paymentRef = params.referencia;
    }
    else params = { ...dataInvoice }.consulta
        .reduce((k: any, index: any) => (
            { ...k, [index.parametro]: index.value }
        ), {})

    let RequestInvoice = null;
    await lazyRequest(params, count, (invo: any) => RequestInvoice = invo, pending)
    if (RequestInvoice) {
        RequestInvoice = CreateInvoiceGroup([RequestInvoice])
        handler(RequestInvoice[0])
        return
    }

    //controlar una bandera si no repsondi la factura
    handler(dataInvoice);
}


//////////////////////////////////
// CONSULT INVOICE INDIVIDUAL ::::
export const consult_individual_invoices = (
    invoices: any,
    pending: any,
    handler: (data: any) => void,
    filial: number
) => {

    sessionStorage.removeItem(newInvoceStorage);
    sessionStorage.removeItem(cartsIdStorage);
    sessionStorage.removeItem(UFStorage);

    [...invoices].map((invoice: any) =>
        ControlInvoiceResponse(invoice, handler, filial, pending)
    )
}


//////////////////////////////////
// update variables ::::
export function HandlerVariables(
    invoice: any,
    invoices: any,
    pending: any,
    param: string
) {
    let id = invoice[param];
    const Invoices = [...invoices].map((item: any) => {
        if (item[param] === id) return invoice
        else return item;
    })
    const Pending = [...pending].filter((inv: any) => inv !== id);
    return ({
        invoicesN: Invoices,
        pendingItemsN: Pending
    })
}

export async function getGeoIp() {
    try {
        const response = await axios.get(config.REACT_APP_GEO_IP_URL!);
        return response.data;
    } catch (error) {
        console.error(error);
    }
}

export async function getSessionId(data: any) {
    try {
        const response = await axios({
            url: config.sessionId,
            method: "POST",
            data,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        })

        if (!response.data.success) {
            console.error(response.data.message);
            throw new Error(response.data.message);
        }

        return response.data;
    } catch (error) {
        console.error(error);
    }
}


